import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Actions, Select, Store, ofActionDispatched } from '@ngxs/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { Module } from '../../../module/models/module.model';
import { FetchAllModules, FetchAllModulesSuccess } from '../../actions';
import { AllModulesState } from '../../models/all-modules.state';

export class AllModuleDataSource implements DataSource<Module> {
    @Select(AllModulesState.getFiltersList)
    filter$: Observable<Module>;

    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    constructor(private _filteredModule$: Observable<Module[]>, private _store: Store, private _action$: Actions) {}

    connect(collectionViewer: CollectionViewer): Observable<Module[]> {
        return this._filteredModule$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    loadModules(
        filterValues?: { [key: string]: string[] },
        search?: string,
        sortBy?: string,
        sortOrder?: string,
        pageSize?: number,
        pageNumber?: number,
        patchState?: boolean,
        kind?: string,
        context?: string
    ): void {
        this._loadingSubject.next(true);

        this._store.dispatch(
            new FetchAllModules({
                filterValues,
                search,
                sortBy,
                sortOrder,
                pageSize,
                pageNumber,
                patchState,
                kind,
                context,
            })
        );
        this._action$
            .pipe(
                ofActionDispatched(FetchAllModulesSuccess),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
